import React from 'react';
import { motion } from 'framer-motion';
interface VinylRecordProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  labelColor?: string;
  isPlaying?: boolean;
}
export function VinylRecord({
  size = 'md',
  className = '',
  labelColor = 'bg-neon-magenta',
  isPlaying = true
}: VinylRecordProps) {
  const sizeClasses = {
    sm: 'w-24 h-24',
    md: 'w-48 h-48',
    lg: 'w-64 h-64',
    xl: 'w-96 h-96 md:w-[500px] md:h-[500px]'
  };
  return <div className={`relative rounded-full p-1 bg-gray-800 shadow-2xl ${sizeClasses[size]} ${className}`} data-id="element-216">
      {/* Outer rim */}
      <motion.div className="w-full h-full rounded-full bg-black vinyl-grooves relative flex items-center justify-center shadow-xl border-4 border-gray-900" animate={isPlaying ? {
      rotate: 360
    } : {
      rotate: 0
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-217">
        {/* Shine reflection */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-white/10 to-transparent pointer-events-none" data-id="element-218" />

        {/* Label */}
        <div className={`w-1/3 h-1/3 rounded-full ${labelColor} flex items-center justify-center border-4 border-black relative`} data-id="element-219">
          <div className="w-2 h-2 bg-white rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-220" />
          <span className="text-[0.5em] font-bold text-black uppercase tracking-widest opacity-80 rotate-45" data-id="element-221">
            Lutegames
          </span>
        </div>
      </motion.div>
    </div>;
}